import "../css/admin.scss";

export default function SyndicateRoom() {
  return (
    <div className='syndicateroom-container'>
        Yet to be implemented.
    </div>
  )
}
